/**
 * Flashcard Entity
 * Represents a single flashcard (question/answer pair)
 *
 * DB Table: Flashcards
 * - id (PK)
 * - deck_id (FK)
 * - front (question)
 * - back (answer)
 * - sort_order
 * - tags
 */
export interface FlashcardProps {
  id: string;
  deckId: string;
  front: string;
  back: string;
  sortOrder: number;
  tags: string[];
  createdAt: Date;
  updatedAt: Date;
}

export class Flashcard {
  private readonly props: FlashcardProps;

  constructor(props: FlashcardProps) {
    this.props = props;
  }

  get id(): string {
    return this.props.id;
  }

  get deckId(): string {
    return this.props.deckId;
  }

  get front(): string {
    return this.props.front;
  }

  get back(): string {
    return this.props.back;
  }

  get sortOrder(): number {
    return this.props.sortOrder;
  }

  get tags(): string[] {
    return this.props.tags;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get updatedAt(): Date {
    return this.props.updatedAt;
  }

  getFrontPreview(maxLength: number = 100): string {
    if (this.props.front.length <= maxLength) return this.props.front;
    return this.props.front.substring(0, maxLength) + '...';
  }

  getBackPreview(maxLength: number = 100): string {
    if (this.props.back.length <= maxLength) return this.props.back;
    return this.props.back.substring(0, maxLength) + '...';
  }

  hasTags(): boolean {
    return this.props.tags.length > 0;
  }

  belongsToDeck(deckId: string): boolean {
    return this.props.deckId === deckId;
  }

  toPlainObject(): FlashcardProps {
    return { ...this.props };
  }
}
